import { render } from "./RouteItem.vue?vue&type=template&id=63e2f5cf"
import script from "./RouteItem.vue?vue&type=script&lang=js"
export * from "./RouteItem.vue?vue&type=script&lang=js"

import "./RouteItem.vue?vue&type=style&index=0&id=63e2f5cf&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__